import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent implements OnInit {
  public grch37Available = false;
  public isLoading = true;
  public error: HttpErrorResponse | undefined;

  constructor(
    private router: Router,
    private api: ApiService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkGRCh37Availability();
  }

  checkGRCh37Availability(): void {
    this.spinner.show();
    this.api.getGRCh37Datasets().subscribe({
      next: (datasets) => {
        this.grch37Available = datasets.length > 0;
        this.isLoading = false;
        this.spinner.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.grch37Available = false;
        this.isLoading = false;
        this.spinner.hide();
      },
    });
  }

  navigateToGWAS15(): void {
    if (this.grch37Available) {
      this.router.navigate(['/gwas-15']);
    }
  }

  navigateToGWAS16(): void {
    this.router.navigate(['/gwas-16']);
  }
}
